import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const OrganizationEvents = lazy(() => import('./events-page'));

export const OrganizationEventsRoute = () => {
  return (
    <LazyRoute>
      <OrganizationEvents />
    </LazyRoute>
  );
};
